<div class="inquiry">

  <div class="inquiryList">
    <div class="search">
      <div class="inquiryTitle mr20">
        <nz-breadcrumb nzSeparator=">" class="breadcrumb">
          <nz-breadcrumb-item>{{'inquiry.helpdesk' | translate }}</nz-breadcrumb-item>
          <nz-breadcrumb-item>{{'inquiry.list' | translate }}</nz-breadcrumb-item>
        </nz-breadcrumb>
        <button mat-raised-button color="primary" class="addTicket"  (click)="addTicket()">+ {{'inquiry.newTicket' | translate }}</button>
      </div>
      <form nz-form class="ant-advanced-search-form">
        <nz-form-item>
          <nz-form-control>
            <nz-input-group [nzSuffix]="suffixIconSearch">
              <input type="text" [ngModelOptions]="{standalone: true}" nz-input  (keyup)="($event.which === 13) ? searchInquiryList(true) : 0"
                placeholder="{{'input.keyword' | translate}}" [(ngModel)]="keywords" class="w500" />
            </nz-input-group>
            <ng-template #suffixIconSearch>
              <span
                nz-icon
                class="ant-input-clear-icon"
                nzTheme="fill"
                nzType="close-circle"
                *ngIf="keywords"
                (click)="keywords = '';searchInquiryList(true)"
              ></span>
            </ng-template>
          </nz-form-control>
          <nz-form-control class="ml20">
            <button mat-raised-button color="primary" class="addTicket" (click)="!keywords || keywords.trim() === '' ? GetTicketPage() : searchInquiryList()" >{{ 'button.refresh' | translate}}</button>
          </nz-form-control>

        </nz-form-item>
      </form>
    </div>

    <!-- Enhanced Loading Overlay -->
    <div *ngIf="isCurrentlyLoading()" class="enhanced-loading-overlay">
      <div class="loading-backdrop"></div>
      <div class="loading-container">
        <div class="loading-card">
          <div class="loading-header">
            <h3>Loading Ticket Information</h3>
            <div class="loading-time">{{ getLoadingTime() }}</div>
          </div>

          <!-- Progress Bar -->
          <div class="progress-section">
            <nz-progress
              [nzPercent]="getLoadingPercentage()"
              [nzStatus]="'active'"
              [nzShowInfo]="false"
              [nzStrokeWidth]="8">
            </nz-progress>
            <div class="progress-text">{{ getLoadingPercentage() }}%</div>
          </div>

          <!-- Loading Message with Icon -->
          <div class="loading-message">
            <span nz-icon nzType="loading" nzTheme="outline" class="loading-icon"></span>
            <span class="message-text">{{ loadingMessage }}</span>
          </div>

          <!-- Loading Steps -->
          <div class="loading-steps">
            <div class="step-title">Progress Steps:</div>
            <div class="steps-list">
              <div
                *ngFor="let step of loadingSteps; let i = index"
                class="step-item"
                [class.completed]="i < currentLoadingStep"
                [class.current]="i === currentLoadingStep"
                [class.pending]="i > currentLoadingStep">
                <span class="step-icon">
                  <span nz-icon
                    *ngIf="i < currentLoadingStep"
                    nzType="check-circle"
                    nzTheme="fill"
                    class="step-success">
                  </span>
                  <span nz-icon
                    *ngIf="i === currentLoadingStep"
                    nzType="loading"
                    nzTheme="outline"
                    class="step-current">
                  </span>
                  <span nz-icon
                    *ngIf="i > currentLoadingStep"
                    nzType="clock-circle"
                    nzTheme="outline"
                    class="step-pending">
                  </span>
                </span>
                <span class="step-text">{{ step }}</span>
              </div>
            </div>
          </div>

          <!-- Debug Information (only shown in development) -->
          <div *ngIf="loadingMessage.includes('❌')" class="error-info">
            <div class="error-title">Error Details:</div>
            <div class="error-message">{{ loadingMessage }}</div>
            <button nz-button nzType="primary" nzSize="small" (click)="searchInquiryList()">
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tableList">
      <nz-table appTableAdapt  [nzFrontPagination]="false" #sortTable [nzData]="listOfData" [nzShowTotal]="totalTemplate" [nzPageSizeOptions]="[ 10, 20, 30, 40, 50 ]"
        [nzLoading]="loading" [nzTotal]="total" [(nzPageIndex)]="pageIndex" [(nzPageSize)]="pageSize" nzShowSizeChanger
        (nzPageIndexChange)="searchInquiryList()" (nzPageSizeChange)="searchInquiryList(true)" nzTableLayout="fixed">
        <thead>

          <tr>
            <th nzColumnKey="ticketNo" nzWidth="82px" nzLeft="0px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['ticketNo'].order" (nzSortOrderChange)="onSortParamsChange($event,'ticketNo')">
              {{'ticket.ticketNo' | translate }}
            </th>
            <th nzColumnKey="fullName" nzWidth="105px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['fullName'].order" (nzSortOrderChange)="onSortParamsChange($event,'fullName')">
              {{'ticket.fullName' | translate }}
            </th>
            <th nzColumnKey="submittedDate" nzCustomFilter  nzWidth="100px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['submittedDate'].order" (nzSortOrderChange)="onSortParamsChange($event,'submittedDate')">
              {{'ticket.submittedDate' | translate }}
              <nz-filter-trigger [(nzVisible)]="isSubmittedDateVisible" [nzDropdownMenu]="submittedDateMenu">
                <span nz-icon nzType="down" nzTheme="outline"></span>
              </nz-filter-trigger>
            </th>
            <th nzColumnKey="status"  nzWidth="78px" [nzFilters]="ticketStatusList" [nzFilterFn]="true" (nzFilterChange)="onFilterParamsChange($event,'status')">
              {{'ticket.status' | translate }}
            </th>
            <th nzColumnKey="severityLevel" nzWidth="70px">
              {{'ticket.severityLevel' | translate }}
            </th>
            <th nzColumnKey="problemCategory" nzWidth="100px" [nzFilters]="problemCategoryList"  [nzFilterFn]="true" (nzFilterChange)="onFilterParamsChange($event,'problemCategory')">
              {{'ticket.problemCategory' | translate }}
            </th>
            <th nzColumnKey="problemSubCategory" nzWidth="110px">
              Problem SubCategory
            </th>
            <th nzColumnKey="courseLecturer" nzWidth="110px">
              Course Lecturer
            </th>
            <!-- VDI-specific columns (show when VDI category selected) -->
            <th nzColumnKey="vdiStatus" nzWidth="90px" *ngIf="isVDICategorySelected()">
              VDI Status
            </th>
            <th nzColumnKey="vdiSoftware" nzWidth="120px" *ngIf="isVDICategorySelected()">
              Software Set
            </th>
            <th nzColumnKey="vdiSchedule" nzWidth="150px" *ngIf="isVDICategorySelected()">
              Session Period
            </th>
            <th nzColumnKey="description" nzCustomFilter nzWidth="100px" >
              {{'ticket.description' | translate }}
            </th>
            <th nzColumnKey="assignedTeam" nzWidth="88px" [nzFilters]="supportTeamList"  [nzFilterFn]="true" (nzFilterChange)="onFilterParamsChange($event,'assignedTeam')">
              {{'ticket.assignedTeam' | translate }}
            </th>
            <th nzColumnKey="acceptBy" nzCustomFilter nzWidth="105px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['acceptBy'].order" (nzSortOrderChange)="onSortParamsChange($event,'acceptBy')">
              {{'ticket.acceptBy' | translate }}
              <nz-filter-trigger [(nzVisible)]="isAcceptBySearch" [nzDropdownMenu]="acceptBySearchMenu">
                <span nz-icon nzType="search"></span>
              </nz-filter-trigger>
            </th>
            <th nzColumnKey="acceptDate" nzCustomFilter nzWidth="88px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['acceptDate'].order" (nzSortOrderChange)="onSortParamsChange($event,'acceptDate')">
              {{'ticket.acceptDate' | translate }}
              <nz-filter-trigger [(nzVisible)]="isAcceptDateVisible" [nzDropdownMenu]="acceptDateMenu">
                <span nz-icon nzType="down" nzTheme="outline"></span>
              </nz-filter-trigger>
            </th>
            <th nzColumnKey="closedBy" nzWidth="105px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['closedBy'].order" (nzSortOrderChange)="onSortParamsChange($event,'closedBy')" >
              {{'ticket.closedBy' | translate }}
            </th>
            <th nzColumnKey="closedDate" nzCustomFilter nzWidth="88px" [nzSortFn]="true" [nzSortDirections]="['ascend', 'descend']"
              [nzSortOrder]="sortStates['closedDate'].order" (nzSortOrderChange)="onSortParamsChange($event,'closedDate')">
              {{'ticket.closedDate' | translate }}
              <nz-filter-trigger [(nzVisible)]="isClosedDateVisible" [nzDropdownMenu]="closedDateMenu">
                <span nz-icon nzType="down" nzTheme="outline"></span>
              </nz-filter-trigger>
            </th>
          </tr>
        </thead>
        <tbody *ngIf="listOfData.length>0">
          <tr *ngFor="let data of listOfData" (click)="showInfo(data)" [class.loading-row]="isLoadingTicket && data.ticket.id === ticketId">
            <td style="white-space: nowrap;">
              <span *ngIf="isLoadingTicket && data.ticket.id === ticketId" class="loading-indicator">
                <span nz-icon nzType="loading" nzTheme="outline"></span>
              </span>
              <span [class.loading-text]="isLoadingTicket && data.ticket.id === ticketId">
                {{ data.ticket.ticketNo }}
              </span>
            </td>
            <td>{{data.submittedByName || data.ticket.submittedBy}}</td>
            <td>{{ data.ticket.submittedDate || data.ticket.createdDate | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>
              <div class="statuscss"
                [ngClass]="{'closed':data.ticket.ticketStatusID == 3,'inp':data.ticket.ticketStatusID == 2 || data.ticket.ticketStatusID == 4,'submitted':data.ticket.ticketStatusID == 1,'canceled':data.ticket.ticketStatusID == 5}">
                {{getStatus(data.ticket.ticketStatusID || 0)}}</div>
            </td>
            <td>Level {{ data.ticket.severityLevel}}</td>
            <td>{{lang == 'en'?data.ticket.subCategory?.category?.categoryDescrEng: data.ticket.subCategory?.category?.categoryDescrChi }}</td>
            <td *ngIf="isAzureVDITicket(data.ticket)">{{lang == 'en'?data.ticket.subCategory?.subCategoryDescrEng: data.ticket.subCategory?.subCategoryDescrChi }}</td>
            <td *ngIf="!isAzureVDITicket(data.ticket)">-</td>
            <td *ngIf="!isAzureVDITicket(data.ticket)">{{lang == 'en'?data.ticket.subCategory?.subCategoryDescrEng: data.ticket.subCategory?.subCategoryDescrChi }}</td>
            <td *ngIf="isAzureVDITicket(data.ticket)">-</td>
            <!-- VDI-specific data cells -->
            <td *ngIf="isVDICategorySelected()">
              <nz-tag *ngIf="data.ticket.vdiStatus" [nzColor]="getVDIStatusColor(data.ticket.vdiStatus || '')">
                {{ data.ticket.vdiStatus }}
              </nz-tag>
              <span *ngIf="!data.ticket.vdiStatus">-</span>
            </td>
            <td *ngIf="isVDICategorySelected()">
              <span *ngIf="data.ticket.softwareSet">{{ data.ticket.softwareSet }}</span>
              <span *ngIf="!data.ticket.softwareSet">-</span>
            </td>
            <td *ngIf="isVDICategorySelected()">
              <div *ngIf="data.ticket.scheduleStartUtc" style="font-size: 11px;">
                {{ data.ticket.scheduleStartUtc | date:'dd/MM HH:mm' }} - {{ data.ticket.scheduleEndUtc | date:'dd/MM HH:mm' }}
              </div>
              <span *ngIf="!data.ticket.scheduleStartUtc">-</span>
            </td>
            <td nzBreakWord><div class="textOverFlow" nzTooltipTitle="{{data.ticket.detail}}" nzTooltipPlacement="top" nz-tooltip>{{ data.ticket.detail }}</div></td>
            <td>{{data.ticket.assignedToTeam?.name }}</td>
            <td>{{data.acceptedByName || data.ticket.acceptedBy}}</td>
            <td>{{data.ticket.acceptedDate | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{data.closedByName || data.ticket.closedBy}}</td>
            <td >{{data.ticket.closedDate | date:'dd/MM/yyyy HH:mm'}}</td>
          </tr>
        </tbody>
        <tbody *ngIf="listOfData.length == 0">
          <tr>
            <td colspan="15"><nz-empty [nzNotFoundContent]="contentTpl"></nz-empty>
              <ng-template #contentTpl>
                <span>
                  {{'ticket.empty' | translate }}
                </span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <nz-dropdown-menu #submittedDateMenu="nzDropdownMenu">
        <nz-card style="width:300px;">
          <nz-range-picker [(ngModel)]="submittedDate" (ngModelChange)="searchInquiryList(true)"> </nz-range-picker>
        </nz-card>
      </nz-dropdown-menu>
      <nz-dropdown-menu #closedDateMenu="nzDropdownMenu">
        <nz-card style="width:300px;">
          <nz-range-picker  [(ngModel)]="closedDate" (ngModelChange)="searchInquiryList(true)" ></nz-range-picker>
        </nz-card>
      </nz-dropdown-menu>
      <nz-dropdown-menu #acceptDateMenu="nzDropdownMenu">
        <nz-card style="width:300px;">
          <nz-range-picker [(ngModel)]="acceptDate" (ngModelChange)="searchInquiryList(true)"  ></nz-range-picker>
        </nz-card>
      </nz-dropdown-menu>
      <nz-dropdown-menu #acceptBySearchMenu="nzDropdownMenu">
        <div class="ant-table-filter-dropdown">
          <div class="search-box">
            <input type="text" nz-input placeholder="Search acceptBy" [(ngModel)]="acceptBySearch" (keyup)="($event.which === 13) ? searchInquiryList(true) : 0"   />
            <button nz-button nzSize="small" nzType="primary" (click)="searchInquiryList(true)"  class="search-button"> {{'button.search' | translate }}</button>
            <button nz-button nzSize="small" (click)="acceptBySearch='';searchInquiryList(true)">{{'button.reset' | translate }}</button>
          </div>
        </div>
      </nz-dropdown-menu>

      <ng-template #totalTemplate> {{'form.total' | translate }} {{total}} {{'form.row' | translate }}</ng-template>
    </div>
  </div>
</div>

<nz-drawer [nzClosable]="false" [nzMaskStyle]="MaskStyle" [nzBodyStyle]="{ overflow: 'auto'}" [nzWidth]="1200"
  [nzVisible]="ticketVisible" (nzOnClose)="close()">
  <ng-container *nzDrawerContent>
    <app-ticket #ticketInfomation (isClose)="close()" (ticketSubmitted)="GetTicketPage()" (ticketClosed)="GetTicketPage()" (ticketAccepted)="GetTicketPage()" (ticketApproved)="GetTicketPage()" [ticketId]="ticketId" [ticketGuid]="ticketGuid" [ticketInfo]="ticketInfo"  [resolutionTypeList]="resolutionTypeList" [problemCategoryList]="ticketProblemCategoryList"
     [categoryCode]="categoryCode"  [subCategoryCode]="subCategoryCode" [isAddBtn]="isAddBtn" [description]="description"
         *ngIf="ticketVisible"></app-ticket>
  </ng-container>
</nz-drawer>
